<template>
    <div id="login">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <div class="content">
            <div class="container">
                <h2 class="title2">會員 / 保戶登入</h2>
                <div class="loginTitle">若要投保、續保、變更查詢保單，或使用相關保戶服務，請先進行登入。</div>

                <div class="inputControl" @change="checkAccount">
                    <div class="inputTitle">帳號</div>
                    <div class="inputWrapper">
                        <input type="password" name="" class="inputStyle tlf_n_l5 clarity-mask"  id="assuredIdNo_login" :class="{ 'alert': check1 }" placeholder="既有會員請輸入身分證/居留證號進行登入"
                            v-model="acc" @keyup="upper" autocomplete="new-password"/>
                        <p class="alertStr"></p>
                        <div v-if="isMasked" @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/close_eye.svg"></div>
                        <div  v-else @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/open_eye.svg"></div>
                    </div>
                </div>
                <div class="inputControl">
                    <BirthdayChange :dateTimeProps="birthdayAll" :key="reloadYearChangeKey" @getDateTime="getApplicantBirthday" ref="yearRef" nickName="loginBirthday"/>
                </div>
<!--                <router-link :to="'/register'" class="link center login_register_accu">還不是會員嗎？立即註冊</router-link>
                <p class="center"><span class="red">提醒您：</span>會員即是要保人，也是繳交保費的付款人。</p>-->
                <div class="bottomTxt">
                    <p class="center">還不是會員？初次投保請填寫資料加入會員</p>
                    <div class="center"><router-link :to="'/register'" class="link">立即填寫資料</router-link></div>
                </div>

            </div>
        </div>
        <div class="anotherBtn center">
            <div @click="$router.back()" class="btn back login_back_accu">返回</div>
            <button class="btn confirm login_go_accu" @click="login">確定</button>
        </div>
        <div class="attentionTxt center">
            <img src='noticemark.svg' class='attention'>
            <ul>
                <li>會員即是要保人，也是繳交保費的保費的付款人。</li>
            </ul>
        </div>
    </div>
</template>
<script setup>

import Loading from "@/components/loading.vue";
import {popUp} from "@/utils/popUp";
import {onMounted, ref} from "vue";
import gtm from "@/utils/gtmDataLayer";
import {useRouter} from "vue-router";
import _ from "lodash"
import Swal from "sweetalert2";
import {postApi} from "@/utils/callApi";
import apiConfig from "@/utils/apiConfig";
import BirthdayChange from "@/components/birthdayChange.vue";
import CheckData from "@/utils/checkData";


        const router = useRouter();//轉跳router

        let jwtInfo = null;
        let startCheck = false;//開始驗證
        let logData = null;//登入資料
        const isMasked = ref(true); // 隱碼狀態
        const acc = ref("");//使用者輸入帳號
        const isLoading = ref(false);
        const check1 = ref(false);//身分證字號檢核
        const check2 = ref(false);//生日檢核
        const birthdayAll = ref({});//生日
        const reloadYearChangeKey = ref(0);
        const yearRef = ref();

        //初始載入檢查登入
        const checkLogin = ()=>{
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            if(jwtInfo != null){
                router.push("/");
            }
        }

        //初始載入檢查登入
        const loadLogData = ()=>{
            if(logData != null){

                acc.value = logData.acc;
                birthdayAll.value = logData.birthday;
                reloadYearChangeKey.value += 1;
            }
        }

        //輸入身分證時轉大寫
        const upper = _.debounce(()=>{
            if(acc.value !== ""){
                acc.value = acc.value.toString().toUpperCase();
                acc.value = CheckData.convertToHalfWidth(acc.value);
            }
        },50)

        const getApplicantBirthday = (data)=>{
            birthdayAll.value = data;
        }

        //檢查登入輸入資料
        const checkAccount = ()=>{
            if(startCheck){
                if(acc.value === "" || acc.value === null){
                    check1.value = true;
                }else{
                    check1.value = false;
                }
                if (JSON.stringify(birthdayAll.value) === "{}") {
                    check2.value = true;
                }else{
                    check2.value = false;
                }
                if (birthdayAll.value.year === "" ||birthdayAll.value.year == null
                    || birthdayAll.value.month === "" || birthdayAll.value.month == null
                    || birthdayAll.value.date === "" || birthdayAll.value.date == null) {
                    check2.value = true;
                }else{
                    check2.value = false;
                }
                //觸發 yearChange checkForm();
                yearRef.value?.checkForm(true);
            }
        }

        //發送登入OTP
        const login = ()=>{
            acc.value = acc.value.trim();//清除空白
            startCheck = true;
            checkAccount();

            let checkFlag = 0;
            let errorMsg = [];

            if(check1.value){
                checkFlag++;
                errorMsg.push('請輸入帳號');
            }
            if(check2.value){
                checkFlag++;
                errorMsg.push('生日填寫錯誤');
            }

            if(checkFlag === 0){
                isLoading.value = true;
                // 系統沒有超載才可以進行登入
                logData = {
                    acc: acc.value,
                    birthday:birthdayAll.value
                }
                sessionStorage.setItem('logData',JSON.stringify(logData));
                sessionStorage.setItem('otpType','login');
                router.push("/otp");
            }else{
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>'+ errorMsg + '</p>',
                })
                isLoading.value = false;
            }
            if(acc.value !== null){
                const fpcInfo = JSON.parse(sessionStorage.getItem("fpcInfo"));
                postApi(apiConfig.event, null, null, null,{
                    tagName: "(新保)保費登入頁_身分證字號",
                    tagValue: acc.value,
                    sessionId: fpcInfo.sessionId,
                    fpc: fpcInfo.fpc,
                    clarityId: fpcInfo.clarityId,
                    insuranceType: "旅平險",
                })
            }
        }
// 切換隱碼狀態
const toggleMask = () => {
    let assuredIdNo = document.getElementById("assuredIdNo_login")
    let word = assuredIdNo.getAttribute('type');
    console.log(word)
    if (isMasked.value ||word ==='password') {
        assuredIdNo.setAttribute('type','text')
    } else {
        assuredIdNo.setAttribute('type','password')
    }
    isMasked.value = !isMasked.value;
};

        onMounted(()=>{
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent
            checkLogin();
            loadLogData();
        });

</script>
<style lang="scss">
#login {
    h2{
        padding: 0;
        margin-bottom:10px;
    }
    .loginTitle{
        text-align: center;
        font-size:16px;
        margin-bottom:50px;
    }

    .inputWrapper {
        display: flex;
        align-items: center;
        position: relative;
        flex-direction: column;
    }
    .eyeIcon {
        position: absolute;
        right: 10px;
        cursor: pointer;
        margin-right: 10px;
        margin-top: 10px;
    }
    .content {
        .inputControl {
            margin: 50px auto 50px;
            width: 75%;
        }

        .link {
            display: block;
        }



      @media screen and (max-width: $small){
        .inputControl{
          width:100%;
        }
      }
    }
    .bottomTxt{margin-top:50px;}
    .attentionTxt{
        display:flex;
        color:$textColor;
        width:400px;
        font-weight:400;
        margin:30px auto 80px;
        align-items: baseline;
        .attention{
            top:5px;
        }
        @media screen and (max-width: $small){
            width:90%
        }
    }
}


</style>
